import { Trash2, Plus } from "lucide-react";

export const DEFAULT_RATES = [
  { duration: "30 min", price: 100 },
  { duration: "1 hour", price: 150 },
  { duration: "2 hours", price: 300 },
  { duration: "3 hours", price: 450 },
  { duration: "4 hours", price: 580 },
  { duration: "5 hours", price: 700 },
  { duration: "6 hours", price: 830 },
  { duration: "7 hours", price: 950 },
  { duration: "8 hours", price: 1100 },
];

let _rowSeq = 0;
const newRowId = () => `r${Date.now()}_${++_rowSeq}`;

export const seedRowIds = (rates) =>
  (rates || []).map((r) => ({ _rid: r._rid || newRowId(), ...r }));

export function RateEditor({ rates, onChange }) {
  const setRow = (idx, patch) => {
    const next = [...rates];
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  };

  const removeRow = (idx) => {
    const next = [...rates];
    next.splice(idx, 1);
    onChange(next);
  };

  const addRow = () =>
    onChange([...rates, { _rid: newRowId(), duration: "", price: "" }]);

  const loadDefault = () =>
    onChange(DEFAULT_RATES.map((r) => ({ _rid: newRowId(), ...r })));

  return (
    <div className="md:col-span-2">
      <div className="flex items-center justify-between mb-3">
        <div className="label-luxury">Rates (Duration · Price €)</div>
        <div className="flex gap-2">
          <button
            type="button"
            data-testid="rates-load-default"
            onClick={loadDefault}
            className="text-[0.6rem] uppercase tracking-[0.25em] text-[var(--gold)] border border-[var(--gold)]/40 px-2 py-1"
          >
            Load Default Card
          </button>
          <button
            type="button"
            data-testid="rates-clear"
            onClick={() => onChange([])}
            className="text-[0.6rem] uppercase tracking-[0.25em] text-red-300 border border-red-300/40 px-2 py-1"
          >
            Clear
          </button>
        </div>
      </div>
      <div className="space-y-2">
        {rates.map((r, idx) => (
          <div
            key={r._rid}
            className="grid grid-cols-[1fr_140px_auto] gap-2 items-center"
          >
            <input
              data-testid={`rate-duration-${idx}`}
              className="luxury-input"
              placeholder="e.g. 1 hour"
              value={r.duration}
              onChange={(e) => setRow(idx, { duration: e.target.value })}
            />
            <input
              data-testid={`rate-price-${idx}`}
              type="number"
              className="luxury-input"
              placeholder="€"
              value={r.price}
              onChange={(e) => setRow(idx, { price: e.target.value })}
            />
            <button
              type="button"
              data-testid={`rate-remove-${idx}`}
              onClick={() => removeRow(idx)}
              className="text-red-300/80 hover:text-red-300 p-2"
            >
              <Trash2 size={14} />
            </button>
          </div>
        ))}
        <button
          type="button"
          data-testid="rate-add"
          onClick={addRow}
          className="text-xs uppercase tracking-[0.25em] text-[var(--gold)] border border-[var(--gold)]/40 px-3 py-2 mt-1"
        >
          <Plus size={12} className="inline mr-1" /> Add Rate Row
        </button>
      </div>
    </div>
  );
}
